"use client";

import { BookingModal, type Stylist } from "@/components/site/BookingModal";

import { GallerySection } from "@/components/site/GallerySection";
import { SiteHeader } from "@/components/site/SiteHeader";
import { HeroSection } from "@/components/site/HeroSection";
import { ServicesMarquee } from "@/components/site/ServicesMarquee";
import { TestimonialsMarquee } from "@/components/site/TestimonialsMarquee";
import { StylistsSection } from "@/components/site/StylistsSection";
import { CtaSection } from "@/components/site/CtaSection";
import { SiteFooter } from "@/components/site/SiteFooter";
import { stylists } from "@/components/site/stylists";

import { useState } from "react";

export default function ClientWrapper() {

    const [active, setActive] = useState<Stylist | null>(null);
    const openDefault = () => setActive(stylists[0]);

    return (
        <div className="main-container">
            <main className="min-h-screen bg-background text-foreground ">
                <SiteHeader onBook={openDefault} />
                <HeroSection onBook={openDefault} />
                <ServicesMarquee />
                <TestimonialsMarquee />
                <StylistsSection onSelect={setActive} />
                <GallerySection />
                <CtaSection onBook={openDefault} />
                <SiteFooter />
                <BookingModal stylist={active} onClose={() => setActive(null)} />
            </main>
        </div>
    );
}